/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs */

const en_admin_resource_form_select_products_for_members_and_visitors = /** @type {(inputs: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select which extras members and visitors can add when they book this resource.`)
};

const de_admin_resource_form_select_products_for_members_and_visitors = /** @type {(inputs: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle aus, welche Extras Mitglieder und Besucher*innen hinzufügen können, wenn sie diese Ressource buchen.`)
};

const es_admin_resource_form_select_products_for_members_and_visitors = /** @type {(inputs: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona los extras que tus miembros y visitantes pueden añadir al reservar este recurso.`)
};

const fr_admin_resource_form_select_products_for_members_and_visitors = /** @type {(inputs: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez les extras que les membres et les visiteurs peuvent ajouter lorsqu'ils réservent cette ressource.`)
};

/** @type {(inputs: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs) => LocalizedString} */
const it_admin_resource_form_select_products_for_members_and_visitors = en_admin_resource_form_select_products_for_members_and_visitors;

/** @type {(inputs: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_select_products_for_members_and_visitors = en_admin_resource_form_select_products_for_members_and_visitors;

/** @type {(inputs: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs) => LocalizedString} */
const pl_admin_resource_form_select_products_for_members_and_visitors = en_admin_resource_form_select_products_for_members_and_visitors;

/** @type {(inputs: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs) => LocalizedString} */
const hu_admin_resource_form_select_products_for_members_and_visitors = en_admin_resource_form_select_products_for_members_and_visitors;

/** @type {(inputs: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs) => LocalizedString} */
const ro_admin_resource_form_select_products_for_members_and_visitors = en_admin_resource_form_select_products_for_members_and_visitors;

/**
* | output |
* | --- |
* | "Select which extras members and visitors can add when they book this resource." |
*
* @param {Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_select_products_for_members_and_visitors = /** @type {((inputs?: Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Select_Products_For_Members_And_VisitorsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_select_products_for_members_and_visitors(inputs)
	if (locale === "de") return de_admin_resource_form_select_products_for_members_and_visitors(inputs)
	if (locale === "es") return es_admin_resource_form_select_products_for_members_and_visitors(inputs)
	if (locale === "fr") return fr_admin_resource_form_select_products_for_members_and_visitors(inputs)
	if (locale === "it") return it_admin_resource_form_select_products_for_members_and_visitors(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_select_products_for_members_and_visitors(inputs)
	if (locale === "pl") return pl_admin_resource_form_select_products_for_members_and_visitors(inputs)
	if (locale === "hu") return hu_admin_resource_form_select_products_for_members_and_visitors(inputs)
	return ro_admin_resource_form_select_products_for_members_and_visitors(inputs)
});
export { admin_resource_form_select_products_for_members_and_visitors as "admin.resource_form.select_products_for_members_and_visitors" }